import Vue from 'vue'
import Router from 'vue-router'
import Lyrics from './views/Lyrics.vue'
import Edit from './views/Edit.vue'
import Add from './views/Add.vue'
import Sheet from './views/Sheet.vue'
import Placeholder from './views/Placeholder.vue'

Vue.use(Router)

export default new Router({
	routes: [
		{
			path: '/',
			name: 'list',
			component: Placeholder
		},
		{
			path: '/songs/add',
			name: 'add',
			component: Add
		},
		{
			path: '/songs/:id/lyrics/:lang/edit',
			name: 'edit',
			component: Edit
		},
		{
			path: '/songs/:id/lyrics/:lang',
			name: 'lyrics',
			component: Lyrics
		},
		{
			path: '/songs/:id/sheet',
			name: 'sheet',
			component: Sheet
		}
	]
})
